import React, { useEffect, useState } from "react";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import "../assets/css/NitexCropTool.scss";
import { ChromePicker } from "react-color";
import { ReactComponent as IconMove } from '../assets/icons/crop/move.svg'
import { ReactComponent as IconCrop } from '../assets/icons/crop/crop.svg'
import { ReactComponent as IconZoom } from '../assets/icons/crop/zoom.svg'
import { ReactComponent as IconZoomOut } from '../assets/icons/crop/zoomOut.svg'
import { ReactComponent as IconRotateRight } from '../assets/icons/crop/rotateRight.svg'
import { ReactComponent as IconHorizontalFlip } from '../assets/icons/crop/horizontalFlip.svg'
import { ReactComponent as IconColorPicker } from '../assets/icons/crop/picker.svg'

const NitexCropTool = ({ imageUrl, setCroppedImageData }) => {
    const [cropper, setCropper] = useState(null);
    const [rotateValue, setRotateValue] = useState(0);
    const [color, setColor] = useState("rgba(255, 255, 255,1)");

    useEffect(() => {
        const image = document.getElementById("nitex__crop__tool_image");
        let initCropper;

        function handleCrop(e) {
            if (e.target.cropper === initCropper) {
                setCroppedImageData(
                    initCropper
                        .getCroppedCanvas({ fillColor: color })
                        .toDataURL("image/jpeg")
                );
            }
        }

        window.addEventListener("ready", handleCrop);
        window.addEventListener("cropmove", handleCrop);

        initCropper = new Cropper(image, {
            background: false
        });
        setCropper(initCropper);

        return () => {
            window.removeEventListener("ready", handleCrop);
            window.removeEventListener("cropmove", handleCrop);
        };
    }, []);

    const handleChangeTool = (action) => {
        switch (action) {
            case "move":
                cropper.setDragMode(action);
                break;
            case "crop":
                cropper.setDragMode(action);
                break;
            case "zoom-in":
                cropper.zoom(0.1);
                break;
            case "zoom-out":
                cropper.zoom(-0.1);
                break;
            case "rotate-left":
                cropper.rotate(-90);
                break;
            case "rotate-right":
                cropper.rotate(90);
                break;
            case "flip-horizontal":
                cropper.scaleX(-cropper.getData().scaleX || -1);
                break;
            case "flip-vertical":
                cropper.scaleY(-cropper.getData().scaleY || -1);
                break;
            default:
        }
        generateCroppedImage();
    };

    const handleRotate = (e) => {
        const { value } = e.target;
        setRotateValue(value);
        cropper.rotateTo(value);
        generateCroppedImage();
    };

    const generateCroppedImage = () => {
        const croppedImage = cropper
            .getCroppedCanvas({ fillColor: color })
            .toDataURL("image/jpeg");
        setCroppedImageData(croppedImage);
    };

    const handleColorChange = (color) => {
        setColor(
            `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
        );
    };

    useEffect(() => {
        if (cropper) {
            generateCroppedImage();
        }
    }, [color]);

    return (
        <main id="nitex__crop">
            <div className="crop-wrapper">
                <div className="canvas">
                    <img
                        id="nitex__crop__tool_image"
                        src={imageUrl}
                        alt="image"
                    />
                </div>
                <div className="crop__toolbar">
                    <button
                        className="toolbar__button"
                        title="Move"
                        onClick={() => handleChangeTool("move")}
                    >
                        <IconMove />
                    </button>
                    <button
                        className="toolbar__button"
                        title="Crop"
                        onClick={() => handleChangeTool("crop")}
                    >
                        <IconCrop />
                    </button>
                    <button
                        className="toolbar__button"
                        title="Zoom In"
                        onClick={() => handleChangeTool("zoom-in")}
                    >
                        <IconZoom />
                    </button>
                    <button
                        className="toolbar__button"
                        title="Zoom Out"
                        onClick={() => handleChangeTool("zoom-out")}
                    >
                        <IconZoomOut />
                    </button>
                    <button
                        className="toolbar__button"
                        title="Rotate Right"
                        onClick={() => handleChangeTool("rotate-right")}
                    >
                        <IconRotateRight />
                    </button>
                    <button
                        className="toolbar__button"
                        title="Flip Horizontal"
                        onClick={() => handleChangeTool("flip-horizontal")}
                    >
                        <IconHorizontalFlip />
                    </button>
                    <div className="toolbar_rotate">
                        <input
                            title="Rotate"
                            type="range"
                            min={0}
                            value={rotateValue}
                            max={360}
                            step={1}
                            onChange={(e) => handleRotate(e)}
                        />
                    </div>
                    <div className="toolbar_colorPicker">
                        <div className="colorPicker-icon">
                            <IconColorPicker />
                        </div>
                        <div className="chromePicker">
                            <ChromePicker
                                width="100%"
                                color={color}
                                onChange={handleColorChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default NitexCropTool;
